var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFewSlots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.599609,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FFF089"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6804 5.87234L10.5398 12.0343H9.16761L9.03125 5.87234H10.6804ZM9.85369 14.6934C9.59517 14.6934 9.37358 14.6025 9.18892 14.4206C9.0071 14.2388 8.91619 14.0172 8.91619 13.7559C8.91619 13.5002 9.0071 13.2814 9.18892 13.0996C9.37358 12.9178 9.59517 12.8269 9.85369 12.8269C10.1065 12.8269 10.3253 12.9178 10.5099 13.0996C10.6974 13.2814 10.7912 13.5002 10.7912 13.7559C10.7912 13.9292 10.7472 14.0868 10.6591 14.2289C10.5739 14.3709 10.4602 14.4846 10.3182 14.5698C10.179 14.6522 10.0241 14.6934 9.85369 14.6934Z",
    fill: "#3D2F0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewSlots);
export default __webpack_public_path__ + "static/media/few-slots.edf15d63e229d0366e880e398bbb6826.svg";
export { ForwardRef as ReactComponent };